import { OrderDesignComment } from "@jasper/client-models";
import {
  Badge,
  Box,
  Button,
  Card,
  Group,
  Modal,
  Stack,
  Text,
  Textarea,
} from "@mantine/core";
import { useEffect, useState } from "react";

interface Props {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  comment?: OrderDesignComment;
  onSave: (params: { translation: string }) => void;
}

export const OrderDesignCommentTranslationModal = ({
  isOpen,
  isLoading,
  onClose,
  comment,
  onSave,
}: Props) => {
  const [translation, setTranslation] = useState<string>();
  const [translationError, setTranslationError] = useState<string>();

  useEffect(() => {
    if (isOpen) {
      setTranslation("");
      setTranslationError(undefined);
    }
  }, [isOpen, comment?.id]);

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTranslation(event.currentTarget.value);
    if (translationError) {
      setTranslationError(undefined);
    }
  };

  const handleSave = () => {
    if (!translation) {
      setTranslationError("Translation is required");
      return;
    }
    setTranslationError(undefined);

    onSave({ translation });
  };

  return (
    <Modal
      opened={isOpen && !!comment}
      onClose={onClose}
      title="Translate comment"
    >
      <Stack gap="md">
        <Card bd="1px solid gray.3" p={0} m={0}>
          <Stack gap={0}>
            <Box bg="gray.0" p="xs">
              <Stack mx={0} gap="md">
                <Badge variant="outline" size="xl">
                  🇫🇷
                </Badge>
                <Text p="xs" size="sm" c="gray">
                  {comment?.comment}
                </Text>
              </Stack>
            </Box>
            <Stack mx={0} gap="md" p="xs">
              <Badge variant="outline" size="xl">
                🇬🇧
              </Badge>
              <Textarea
                placeholder="Enter comment translation"
                styles={{
                  input: {
                    border: "none",
                    outline: "none",
                    boxShadow: "none",
                    borderRadius: "0px",
                  },
                }}
                value={translation}
                onChange={handleChange}
                error={translationError}
              />
            </Stack>
          </Stack>
        </Card>

        <Group justify="flex-end">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button onClick={handleSave} loading={isLoading}>
            Save
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
